<template>
    <card v-bind="cardProps" :to="user._key && (user.model_name === 'user' || user.user_id) ? $spoferanUrl(`/athletes/${user._key}`) : null" :style="{borderTop: `2px solid ${displayColor}`}" class="z-1">
        <card-image :src="user.avatar_thumbnail" :size="{ratio: 1, width: 192, sm: {width: 208}, lg: {width: 192}}">
            <template v-if="user.distance || user.club?.avatar_thumbnail || $slots.image" #default>
				<chip v-if="user.distance" small class="absolute bottom-0 left-0 m-8" :icon="icons.location" x-small>{{ Math.ceil((user.distance / 1000)) }} km</chip>
				<div v-if="user.club && user.club.avatar_thumbnail" class="absolute bottom-0 right-0 m-8">
					<avatar :model="user.club" :size="32"/>
				</div>
				<slot name="image"/>
			</template>
        </card-image>
        <div class="flex flex-column items-start px-12 md:px-16 py-8 w-full overflow-x-hidden">
            <div class="flex w-full mb-1">
                <slot name="subtitle"/>
                <meta-text v-if="!$slots.subtitle" xx-small>{{ user.presentation_type_name }}</meta-text>
                <meta-text v-if="user.club" :color="displayColor" xx-small>{{ user.club.greeting_name }}</meta-text>
            </div>

            <p class="font-heading text-xs leading-spaced font-bold text-heading-color mb-0 truncate w-full">{{ user.display_name }}</p>

            <div class="h-16 flex justify-end w-full">
				<sport-type-text :sport-types="user.sportTypes" class="text-2xs leading-normal" truncate/>
			</div>

        </div>
    </card>
</template>

<script>
import CardMixin from "../Card/CardMixin";
import {locationIcon} from "../../config";

export default {
    name: "UserCard",

    mixins: [CardMixin],

    props: {
        // A user or member model
        user: {
            type: Object,
            required: true
        },

        color: {
            type: String,
            default: null
        },
    },

	data() {
		return {
			icons: {
				location: locationIcon
			}
		}
	},

    computed: {
        displayColor() {
            if (this.color) {
                return this.color;
            }

            return this.user.color ?? this.$config.public.colors.primary;
        }
    }
}
</script>